import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import App from './App.vue'
import router from './router'
import { initSentry } from './utils/sentry'
import './style.css'

const app = createApp(App)

initSentry(app, router)

app.use(createPinia())
app.use(router)
app.use(naive)

app.mount('#app')
